__turbopack_context__.v({
  "className": "digitalfont_823e26c-module___IdOUq__className",
});
